import type { ApplicationStatus } from '@store/creditApplications';

const CONDITIONALLY_APPROVED = {
  label: 'Conditionally App.',
  classes: 'badge-conditionally-approved bg-yellow-200 text-yellow-800',
};

const MAP: Partial<Record<string, { label: string; classes: string }>> = {
  Draft: { label: 'Draft', classes: 'bg-slate-100 text-slate-600' },
  Submitted: { label: 'Submitted', classes: 'badge-submitted' },
  UnderReview: { label: 'Under Review', classes: 'bg-amber-light text-amber' },
  Approved: { label: 'Approved', classes: 'bg-emerald-light text-emerald' },
  ConditionallyApproved: CONDITIONALLY_APPROVED,
  'Conditionally Approved': CONDITIONALLY_APPROVED,
  LegalReview: {
    label: 'Legal Review',
    classes: 'bg-violet-100 text-violet-700',
  },
  Declined: { label: 'Declined', classes: 'bg-crimson-light text-crimson' },
  Dismissed: { label: 'Dismissed', classes: 'bg-slate-200 text-slate-700' },
};

export function getStatusLabel(
  status: ApplicationStatus | string | null | undefined,
): string {
  const mapped = MAP[(status ?? '') as string];
  if (mapped) return mapped.label;
  return status ? String(status) : 'Unknown';
}

interface Props {
  status: ApplicationStatus | string | null | undefined;
  size?: 'default' | 'compact';
}

export default function StatusBadge(props: Props) {
  const entry = () => {
    const mapped = MAP[(props.status ?? '') as string];
    if (mapped) return mapped;
    return {
      label: props.status ? String(props.status) : 'Unknown',
      classes: 'bg-slate-100 text-slate-600',
    };
  };
  return (
    <span
      class={`inline-flex items-center whitespace-nowrap rounded-full font-medium ${props.size === 'compact' ? 'px-2 py-[1px] text-[10px] leading-4' : 'px-2.5 py-0.5 text-[11px]'} ${entry().classes}`}
    >
      {entry().label}
    </span>
  );
}

export function ArchivedBadge(props: { size?: 'default' | 'compact' }) {
  return (
    <span
      class={`inline-flex items-center whitespace-nowrap rounded-full font-medium bg-slate-200 text-slate-700 ${props.size === 'compact' ? 'px-2 py-[1px] text-[10px] leading-4' : 'px-2.5 py-0.5 text-[11px]'}`}
    >
      Archived
    </span>
  );
}
